export const toSnakeCase = (str: string): string => {
  return str.replace(/ /g, "_").toLowerCase();
};

export const fromSnakeCase = (str: string): string => {
  const withSpaces = str.replace(/_/g, " ");
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
};